<template>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
    >
        <v-toolbar color="primary darken-1" dark>
            <img :alt="App.app_name" :src="$t('app.assets.logo')" height="36"/>
            <v-toolbar-title class="ml-0 pl-3">
                <span class="hidden-sm-and-down">{{ App.app_name }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-list
            dense>
            <!-- V-For Links From Menu -->
            <!-- Individual Link (Custom Additional) -->
            <v-link
                title="Dashboard"
                href="/dashboard"
                icon="fa-home"
            />
            <template>
                <v-list-group prepend-icon="mdi-account-circle">
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title>Fisiere</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <v-list-item>
                        <v-link
                            title="Furnizori"
                            :href="{ name: 'suppliers-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                    <v-list-item>
                        <v-link
                            title="Clienti"
                            :href="{ name: 'customers-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                    <v-list-item>
                        <v-link
                            title="Utilaje / Echipamente"
                            :href="{ name: 'equipments-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                    <v-list-item v-if="hasAnyRole(['admin'])">
                        <v-link
                            title="Personal"
                            :href="{ name: 'employees-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                    <v-list-item>
                        <v-link
                            title="Produse si Categorii"
                            :href="{ name: 'products-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>

                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin', 'contabilitate', 'vanzari'])">
                    <template v-slot:activator>
                        <v-list-item-title>Vanzari si service</v-list-item-title>
                    </template>

                    <v-list-item v-if="hasAnyRole(['admin', 'vanzari', 'contabilitate'])">
                        <v-link
                            title="Oferte"
                            :href="{ name: 'offers-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin', 'vanzari', 'contabilitate'])">
                        <v-link
                            title="Fise de intrari/iesiri service"
                            :href="{ name: 'equipment-worksheet-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin', 'vanzari', 'contabilitate'])">
                        <v-link
                            title="Devize de constructii"
                            :href="{ name: 'construction-estimates-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>

                <!--
                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin', 'contabilitate', 'hr'])">
                    <template v-slot:activator>
                        <v-list-item-title>Resurse umane</v-list-item-title>
                    </template>

                    <v-list-item>
                        <v-link
                            title="Pontaj"
                            :href="{ name: 'presence-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item>
                        <v-link
                            title="Planificare Concedii"
                            :href="{ name: 'vacations-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>
                -->

                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin', 'contabilitate', 'logistica', 'achizitii'])">
                    <template v-slot:activator>
                        <v-list-item-title>Logistica si Achizitii</v-list-item-title>
                    </template>

                    <v-list-item v-if="hasAnyRole(['admin', 'contabilitate', 'logistica'])">
                        <v-link
                            title="Comenzi de transport"
                            :href="{ name: 'transports-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin', 'contabilitate', 'achizitii'])">
                        <v-link
                            title="Achizitii interne"
                            :href="{ name: 'internal-aquisitions-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-group v-if="hasAnyRole(['admin', 'contabilitate', 'manager-parc-auto'])" no-action sub-group>
                        <template v-slot:activator>
                            <v-list-item-content>
                                <v-list-item-title>Auto</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-link v-if="hasAnyRole(['admin', 'contabilitate', 'manager-parc-auto'])" title="Alimentari" :href="{ name: 'vehicle-fuels-index' }"/>
                        <v-link v-if="hasAnyRole(['admin', 'contabilitate', 'manager-parc-auto'])" title="Reparatii si revizii" :href="{ name: 'vehicle-maintenances-index' }"/>
                        <v-link v-if="hasAnyRole(['admin', 'contabilitate', 'manager-parc-auto'])" title="Impozite/RCA/ITP" :href="{ name: 'vehicle-expenses-index' }"/>
                    </v-list-group>
                </v-list-group>

                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin', 'hr'])">
                    <template v-slot:activator>
                        <v-list-item-title>Resurse umane</v-list-item-title>
                    </template>

                    <v-list-item v-if="hasAnyRole(['admin', 'hr'])">
                        <v-link
                            title="Prezenta zilnica"
                            :href="{ name: 'employee-presence' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin', 'hr'])">
                        <v-link
                            title="Planificare concedii"
                            :href="{ name: 'employee-holiday-planner' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>

                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin', 'manager-parc-auto', 'contabilitate', 'logistica', 'vanzari'])">
                    <template v-slot:activator>
                        <v-list-item-title>Rapoarte</v-list-item-title>
                    </template>

                    <v-list-item>
                        <v-link
                            title="Facturi fiscale"
                            :href="{ name: 'invoices-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item>
                        <v-link
                            title="Facturi status oferte"
                            :href="{ name: 'report-offers-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item>
                        <v-link
                            title="Produse ofertate"
                            :href="{ name: 'product-sales-report-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin'])">
                        <v-link
                            title="Raport evolutie oferte"
                            :href="{ name: 'offer-evolution-report-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['manager-parc-auto', 'admin'])">
                        <v-link
                            title="Raport flota vehicule"
                            :href="{ name: 'vehicle-report-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>

                <v-list-group prepend-icon="mdi-account-circle" v-if="hasAnyRole(['admin'])">
                    <template v-slot:activator>
                        <v-list-item-title>Administrare</v-list-item-title>
                    </template>

                    <v-list-item v-if="hasAnyRole(['admin'])">
                        <v-link
                            title="Operatori si permisiuni"
                            :href="{ name: 'admin-users-and-roles-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>

                    <v-list-item v-if="hasAnyRole(['admin'])">
                        <v-link
                            title="Configuratii"
                            :href="{ name: 'admin-configuration-index' }"
                            icon="supervisor_account"
                        />
                    </v-list-item>
                </v-list-group>
            </template>

            <v-link
                title="Media Manager"
                :href="{ name: 'media-manager' }"
                icon="supervisor_account"
            />

            <v-subheader>Utilizator</v-subheader>
            <!--<v-link
                v-if="isAuthenticated"
                title="Contul meu"
                href="/contul-meu"
                icon="fa-cogs"
            />-->
            <v-link
                v-if="isAuthenticated"
                title="Deconectare"
                href="/auth/logout"
                icon="power_settings_new"
            />
            <!-- Guest Links -->
            <v-link
                v-if="!isAuthenticated"
                title="Autentificare"
                href="/auth/login"
                external
                icon="fa-key"
            />
            <v-link
                v-if="!isAuthenticated"
                title="Inregistrare"
                href="/auth/register"
                icon="fa-user-plus"
            />
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    import VLink from "../components/VLink.vue";
    import ACL from "Mixins/acl";
    import {createNamespacedHelpers} from "vuex";
    const { mapState } = createNamespacedHelpers("auth");

    export default {
        components: {
            VLink
        },
        mixins: [
            ACL
        ],
        data: () => ({
            drawer: false
        }),
        computed: {
            ...mapState({
                isAuthenticated: "isAuthenticated",
            })
        },
        mounted() {
            let self = this;
            Bus.$on("toggleDrawer", function () {
                self.drawer = !self.drawer;
            });
        }
    };
</script>
